import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Machines = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'machine_type', label: 'Type' },
    { key: 'make', label: 'Make' },
    { key: 'model', label: 'Model' },
    { key: 'capacity', label: 'Capacity' },
    { key: 'status', label: 'Status' },
    { key: 'is_active', label: 'Active' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'MCH001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Machine Name' },
    { name: 'machine_type', label: 'Machine Type', placeholder: 'Injection Molding' },
    { name: 'make', label: 'Make', placeholder: 'Manufacturer' },
    { name: 'model', label: 'Model', placeholder: 'Model Number' },
    { name: 'serial_number', label: 'Serial Number', placeholder: 'Serial Number' },
    { name: 'capacity', label: 'Capacity', placeholder: 'Capacity' },
    { name: 'location', label: 'Location', placeholder: 'Location' },
    { name: 'installation_date', label: 'Installation Date', type: 'date' },
    { name: 'last_maintenance_date', label: 'Last Maintenance', type: 'date' },
    { name: 'next_maintenance_date', label: 'Next Maintenance', type: 'date' },
    { 
      name: 'status', 
      label: 'Status', 
      type: 'select',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'MAINTENANCE', label: 'Under Maintenance' },
        { value: 'IDLE', label: 'Idle' },
        { value: 'BREAKDOWN', label: 'Breakdown' },
      ]
    },
    { name: 'is_active', label: 'Active', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Machines"
      endpoint="machines"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN', 'PRODUCTION']}
    />
  );
};

export default Machines;
